import { render } from "./NetworkBehavior.vue?vue&type=template&id=54b5e210&scoped=true"
import script from "./NetworkBehavior.vue?vue&type=script&lang=js"
export * from "./NetworkBehavior.vue?vue&type=script&lang=js"

import "./NetworkBehavior.vue?vue&type=style&index=0&id=54b5e210&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b5e210"]])

export default __exports__